import { backgroundTransitionOnClick, IconFont, Text } from '@byecode/ui'
import type { VariableADTvalue } from '@lighthouse/core'
import React, { forwardRef } from 'react'
import styled from 'styled-components'

import { FieldTypeTag } from '../../../FieldTypeTag'
import type { VariableTree2 } from '../../types'

const SCxListItem = styled.div`
    display: flex;
    align-items: center;
    padding: 7px 16px;
    gap: 8px;
    max-height: 50px;
    min-height: 36px;
    cursor: pointer;
    ${backgroundTransitionOnClick}
`

const SCxInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    overflow: hidden;
`

const SCxRightFill = styled.div`
    min-width: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 4px;
`
const SCxLeftFill = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
    overflow: hidden;
`

interface ListItemProps extends Omit<React.ComponentPropsWithoutRef<'div'>, 'onChange' | 'value' | 'data'> {
    data: VariableTree2
    value?: VariableADTvalue
    onChange?: (value: VariableTree2) => void
    selected?: boolean
    showArrowIcon?: boolean
    styles?: Partial<Record<'leftFill' | 'rightFill' | 'root', React.CSSProperties>>
}

export const ListItem = forwardRef<HTMLDivElement, ListItemProps>(
    ({ data, onChange, selected, showArrowIcon = true, style, styles, ...rest }, ref) => {
        return (
            <SCxListItem
                ref={ref}
                onClick={() => onChange?.(data)}
                style={{ ...style, ...styles?.root }}
                onMouseLeave={data.onMouseLeave}
                onMouseEnter={data.onMouseEnter}
                {...rest}
            >
                <SCxLeftFill style={styles?.leftFill}>
                    {data.icon && <IconFont size={16} type={data.icon} fill="var(--color-gray-400)" />}
                    <SCxInfo>
                        <Text style={{ lineHeight: '16px', wordBreak: 'break-all' }} lineClamp={1} size={14}>
                            {data.label}
                        </Text>
                        {data.description && (
                            <Text color="var(--color-gray-600)" style={{ lineHeight: '16px' }} size={12} lineClamp={1}>
                                {data.description}
                            </Text>
                        )}
                    </SCxInfo>
                </SCxLeftFill>
                <SCxRightFill style={styles?.rightFill}>
                    {selected && <IconFont size={16} type="Tick" color="var(--color-purple-500)" />}
                    <FieldTypeTag type={data.fieldType} innerType={data.fieldInnerType} />
                    {showArrowIcon && <IconFont color="Var(--color-gray-400)" size={16} type="ArrowRightSmall" />}
                </SCxRightFill>
            </SCxListItem>
        )
    }
)
